import { ComposedElement } from "../ComposedElement.mjs";
export var ListNode;

(function (ListNode) {
  var Type;

  (function (Type) {
    Type["BULLETED"] = "bulleted-list";
    Type["NUMBERED"] = "numbered-list";
  })(Type = ListNode.Type || (ListNode.Type = {}));

  function isListNode(value, type) {
    if (type) {
      return ComposedElement.isComposedElement(value, type);
    }

    return ComposedElement.isComposedElement(value) && (value.type === Type.NUMBERED || value.type === Type.BULLETED);
  }

  ListNode.isListNode = isListNode;

  function validateListNode(value) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    if (params.length === 1) {
      var [_validateBlockNode] = params;

      var _isValid = isListNode(value) && ComposedElement.validateComposedElement(value, value.type, function (node) {
        return ListItemNode.validateListItemNode(node, _validateBlockNode);
      });

      return _isValid ? value : null;
    }

    var [type, validateBlockNode] = params;
    var isValid = ComposedElement.validateComposedElement(value, type, function (node) {
      return ListItemNode.validateListItemNode(node, validateBlockNode);
    });
    return isValid ? value : null;
  }

  ListNode.validateListNode = validateListNode;
})(ListNode || (ListNode = {}));

export var ListItemNode;

(function (ListItemNode) {
  ListItemNode.TYPE = 'list-item';

  function isListItemNode(value) {
    return ComposedElement.isComposedElement(value, ListItemNode.TYPE);
  }

  ListItemNode.isListItemNode = isListItemNode;

  function validateListItemNode(value, validateChildNode) {
    var isValid = ComposedElement.validateComposedElement(value, ListItemNode.TYPE, validateChildNode);
    return isValid ? value : null;
  }

  ListItemNode.validateListItemNode = validateListItemNode;
})(ListItemNode || (ListItemNode = {}));

export var ListItemTextNode;

(function (ListItemTextNode) {
  ListItemTextNode.TYPE = 'list-item-text';

  function isListItemTextNode(value) {
    return ComposedElement.isComposedElement(value, ListItemTextNode.TYPE);
  }

  ListItemTextNode.isListItemTextNode = isListItemTextNode;

  function validateListItemTextNode(value, validateChildNode) {
    var isValid = ComposedElement.validateComposedElement(value, ListItemTextNode.TYPE, validateChildNode);
    return isValid ? value : null;
  }

  ListItemTextNode.validateListItemTextNode = validateListItemTextNode;
})(ListItemTextNode || (ListItemTextNode = {}));